import {
  BarChart3,
  Brain,
  ClipboardList,
  Compass,
  HeartHandshake,
  HeartPulse,
  ShieldAlert,
  TrendingUp,
  UsersRound,
  type LucideIcon,
} from "lucide-react";

export const TOPIC_ICONS: Record<string, LucideIcon> = {
  kpis: BarChart3,
  wellbeing: HeartPulse,
  team_chemistry: UsersRound,
  development: TrendingUp,
  action_plan: ClipboardList,
  strengths: Brain,
  risks: ShieldAlert,
  collaboration: HeartHandshake,
  coaching: Compass,
};
